import React, { useEffect } from 'react';
import './App.css';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { Analytics } from '@vercel/analytics/react';
import { BrowserRouter as Router, Route, Routes, useLocation, useNavigationType } from 'react-router-dom';
import ErrorBoundary from './components/errors/error-boundary.js';

import Header from './components/common/header.js';
import Intro from './components/pages/intro.js';
import MainFooter from './components/common/main-footer.js';
import LightFooter from './components/common/light-footer.js';

import Apply from './components/forms/apply.js';
import FAQ from './components/pages/faq.js';
import Investments from './components/pages/investments.js';
import People from './components/pages/people.js';
import PostApply from './components/forms/post-apply.js';
import NextBatch from './components/common/first-believer-fund.js';
import ErrorPage from './components/errors/error-page.js';
import Investors from './components/forms/investors.js';
import ErrorSubmit from './components/errors/error-submit.js';
import LoadingModalDemo from './components/bonus/loading-modal-demo.js';
import Decisions from './components/pages/decisions.js';
import Feedback from './components/pages/feedback.js';
import Finalist from './components/pages/finalist.js';
import Reference from './components/pages/reference.js';

// Create a wrapper component to handle the conditional footer rendering
function AppContent() {
  const location = useLocation();
  const navigationType = useNavigationType();

  // Open each new page at the top. Back/forward (POP) is left alone so the
  // browser can restore the previous scroll position.
  useEffect(() => {
    if (navigationType !== 'POP') {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
  }, [location.pathname, navigationType]);
  const lightFooterPaths = ['/post-apply', '/apply', '/investors', '/decisions', '/feedback'];
  const noFooterPaths = ['/error'];
  const isFinalistPage = location.pathname.startsWith('/finalist') || location.pathname.startsWith('/reference');

  const getFooter = () => {
    if (noFooterPaths.includes(location.pathname) || isFinalistPage) {
      return null;
    }
    if (lightFooterPaths.includes(location.pathname)) {
      return <LightFooter />;
    }
    return <MainFooter />;
  };

  return (
    <ErrorBoundary>
      <>
        {!isFinalistPage && <Header />}
        <Routes>
          <Route path="/" element={<Intro />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/investments" element={<Investments />} />
          <Route path="/people" element={<People />} />
          <Route path="/investors" element={<Investors />} />
          <Route path="/post-apply" element={<PostApply />} />
          <Route path="/next-batch" element={<NextBatch />} />
          <Route path="/error-submit" element={<ErrorSubmit />} />
          <Route path="/loading-modal-demo" element={<LoadingModalDemo />} />
          <Route path="/decisions" element={<Decisions />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/finalist/:id/:token" element={<Finalist />} />
          <Route path="/reference/:id/:token" element={<Reference />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
        {getFooter()}
      </>
    </ErrorBoundary>
  );
}

function App() {
  return (
    <div className="App">
      <Router>
        <AppContent />
      </Router>
      <SpeedInsights />
      <Analytics />
    </div>
  );
}

export default App;

